module.exports = __webpack_public_path__ + "img/Cloud Architecture.92b5d4f3.png";